import { tv, VariantProps } from "tailwind-variants";

import {
  alignVariants,
  colorVariants,
  responsiveVariants,
  weightVariants,
  whitespaceVariants,
} from "../constant";

export const textBodyVariants = tv(
  {
    base: "font-default font-normal tracking-tighter",
    variants: {
      size: {
        1: "text-[length:--text-new-md] md:text-[length:--text-new-xl] leading-loose",
        2: "text-[length:--text-new-base] md:text-[length:--text-new-lg] leading-looser",
        3: "text-[length:--text-new-sm] md:text-[length:--text-new-base] leading-looser",
        4: "text-[length:--text-new-xs] md:text-[length:--text-new-sm] leading-looser",
        5: "text-[length:--text-new-2xs] md:text-[length:--text-new-xs] leading-tight",

      },
      color: {
        ...colorVariants,
      },
      align: {
        ...alignVariants,
      },
      whitespace: {
        ...whitespaceVariants,
      },
      weight: {
        ...weightVariants,
      },

    },
    defaultVariants: {
      size: 1,
      align: "default",
      whitespace: "normal",
      color: "default",
    },
  },
  { responsiveVariants: [ ...responsiveVariants ] },

);

export type TextBodyVariantsProps = VariantProps<typeof textBodyVariants>;
const textBodyStyles = (variants: TextBodyVariantsProps) => textBodyVariants(variants);

export default textBodyStyles;
